import axios from 'axios'
import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import history from 'browserHistory'
import theme from 'theme'
import store from 'store'
import App from 'App'

const authToken = localStorage.getItem('authToken')
axios.defaults.headers.common['Authorization'] = 'Token '.concat(authToken)

const Root = () => (
  <Router history={history}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline/>
          <App />
      </ThemeProvider>
    </Provider>
  </Router>
)

export default Root
